import { render, staticRenderFns } from "./RappelAvocatMail.vue?vue&type=template&id=63d40210&scoped=true"
import script from "./RappelAvocatMail.vue?vue&type=script&lang=js"
export * from "./RappelAvocatMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d40210",
  null
  
)

export default component.exports